/** Broad storage method. Exact temperatures live in the structured
 * `storageTemperatureMinC` / `storageTemperatureMaxC` fields: keeping method
 * and limits separate lets the form represent supplier instructions such as
 * 8–10 °C without adding a new enum for every possible range. */
export const STORAGE_CONDITIONS = ['AMBIENT', 'CHILLED', 'FROZEN', 'HOT_HOLDING'] as const;
export type StorageCondition = (typeof STORAGE_CONDITIONS)[number];
